namespace TabAurous.Sales {
    export interface MaterialOutRow {
        TransId?: number;
        TransDate?: string;
        RefTransId?: number;
        RefVoucherId?: number;
        VoucherNo?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        GstVat?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        RoundOff?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        PostingDate?: string;
        IsPosted?: boolean;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        BillAddId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: MaterialOutItemsRow[];
        DepartmentId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        Username?: string;
    }

    export namespace MaterialOutRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Sales.MaterialOut';
        export const deletePermission = 'Sales:Material:Delete';
        export const insertPermission = 'Sales:Material:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:Material:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            RefTransId = "RefTransId",
            RefVoucherId = "RefVoucherId",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            GstVat = "GstVat",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            RoundOff = "RoundOff",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            BillAddId = "BillAddId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            DepartmentId = "DepartmentId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            Username = "Username"
        }
    }
}
